import type { AcriAnswer } from '@/components/OnboardingQuestionPage'
import OnboardingQuestionPage from '@/components/OnboardingQuestionPage'

const answers: AcriAnswer[] = [
  { title: 'pages.onboarding.industry.technology', value: 'technology' },
  {
    title: 'pages.onboarding.industry.financialServices',
    value: 'financial-services',
  },
  { title: 'pages.onboarding.industry.healthcare', value: 'healthcare' },
  { title: 'pages.onboarding.industry.retail', value: 'retail' },
  { title: 'pages.onboarding.industry.manufacturing', value: 'manufacturing' },
  { title: 'pages.onboarding.industry.media', value: 'media' },
  { title: 'pages.onboarding.industry.consulting', value: 'consulting' },
  { title: 'pages.onboarding.industry.education', value: 'education' },
  { title: 'pages.onboarding.industry.government', value: 'government' },
  { title: 'pages.onboarding.industry.other', value: 'other' },
]

export default function IndustryPage() {
  return (
    <OnboardingQuestionPage
      answers={answers}
      title="pages.onboarding.industry.title"
      layout="grid"
    />
  )
}
